import { render, staticRenderFns } from "./video-ad-element.vue?vue&type=template&id=567b05c6&scoped=true&"
import script from "./video-ad-element.vue?vue&type=script&lang=js&"
export * from "./video-ad-element.vue?vue&type=script&lang=js&"
import style0 from "./video-ad-element.vue?vue&type=style&index=0&id=567b05c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567b05c6",
  null
  
)

export default component.exports